import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import '@/App.css';

import { AuthProvider } from '@/contexts/AuthContext';
import { PlayerProvider } from '@/contexts/PlayerContext';
import ProtectedRoute from '@/components/ProtectedRoute';
import Layout from '@/components/Layout';

import Landing from '@/pages/Landing';
import Auth from '@/pages/Auth';
import ForgotPassword from '@/pages/ForgotPassword';
import SetPassword from '@/pages/SetPassword';
import Terms from '@/pages/Terms';
import Privacy from '@/pages/Privacy';
import Onboarding from '@/pages/Onboarding';
import Home from '@/pages/Home';
import Library from '@/pages/Library';
import Music from '@/pages/Music';
import ColorSound from '@/pages/ColorSound';
import Soundscape from '@/pages/Soundscape';
import Create from '@/pages/Create';
import Challenges from '@/pages/Challenges';
import Journal from '@/pages/Journal';
import Profile from '@/pages/Profile';
import Gifts from '@/pages/Gifts';
import GiftSuccess from '@/pages/GiftSuccess';

function AppShell({ children }) {
    return <Layout>{children}</Layout>;
}

function App() {
    return (
        <div className="App">
            <AuthProvider>
                <PlayerProvider>
                    <BrowserRouter>
                        <Routes>
                            <Route path="/" element={<Landing />} />
                            <Route path="/auth" element={<Auth />} />
                            <Route path="/reset" element={<ForgotPassword />} />
                            <Route path="/reset/email" element={<SetPassword mode="reset" />} />
                            <Route path="/set-password" element={<SetPassword mode="set-password" />} />
                            <Route path="/terms" element={<Terms />} />
                            <Route path="/privacy" element={<Privacy />} />
                            <Route
                                path="/onboarding"
                                element={
                                    <ProtectedRoute requireOnboarding={false}>
                                        <Onboarding />
                                    </ProtectedRoute>
                                }
                            />
                            <Route
                                path="/app/*"
                                element={
                                    <ProtectedRoute>
                                        <AppShell>
                                            <Routes>
                                                <Route index element={<Navigate to="home" replace />} />
                                                <Route path="home" element={<Home />} />
                                                <Route path="library" element={<Library />} />
                                                <Route path="music" element={<Music />} />
                                                <Route path="sound" element={<ColorSound />} />
                                                <Route path="soundscape" element={<Soundscape />} />
                                                <Route path="create" element={<Create />} />
                                                <Route path="challenges" element={<Challenges />} />
                                                <Route path="journal" element={<Journal />} />
                                                <Route path="profile" element={<Profile />} />
                                                <Route path="gifts" element={<Gifts />} />
                                                <Route path="gifts/success" element={<GiftSuccess />} />
                                                <Route path="*" element={<Navigate to="home" replace />} />
                                            </Routes>
                                        </AppShell>
                                    </ProtectedRoute>
                                }
                            />
                            <Route path="*" element={<Navigate to="/" replace />} />
                        </Routes>
                    </BrowserRouter>
                </PlayerProvider>
            </AuthProvider>
        </div>
    );
}

export default App;
